// extracted by mini-css-extract-plugin
export var actionButton = "_rp-0";
export var actionMenuContainer = "_rp-i";
export var bubble = "_rp-2";
export var bubbleActionMenu = "_rp-j";
export var bubbleContext = "_rp-6";
export var bubbleItems = "_rp-7";
export var customer = "_rp-3";
export var divider = "_rp-8";
export var fileList = "_rp-9";
export var hiddenComment = "_rp-o";
export var infoAbove = "_rp-a";
export var internal = "_rp-4";
export var lightActionButton = "_rp-1";
export var link = "_rp-b";
export var merchant = "_rp-5";
export var message = "_rp-c";
export var profilePicture = "_rp-e";
export var quillToolbarContainer = "_rp-f";
export var senderDate = "_rp-g";
export var senderDateCustomer = "_rp-h";
export var senderName = "_rp-d";
export var time = "_rp-k";
export var uploadedImage = "_rp-l";
export var username = "_rp-m";
export var xsmall = "_rp-n";